<template>
  <div class="md-layout">
    <!-- DOWNLOAD PDF -->
    <div class="dashboard" v-if="renderPdf">
      <button
        class="md-button md-info px-3 py-2 btn-download-pdf"
        @click="downloadPdf()"
      >
        {{ $t("pdf.download_pdf") }}
      </button>
      <pdf-default ref="pdfContent" pdf-format="a4" pdf-content-width="775px">
        <template #pdf-content>
          <section class="md-layout">
            <section class="md-layout-item md-size-100 mb-6">
              <div class="w-[185px]">
                <img
                  src="/img/igs-transcript-logo.png"
                  alt="IGS Global image"
                />
              </div>
              <h3 class="font-medium">
                IVY Global School
              </h3>
              <p class="text-xs font-medium">
                8875 Hidden River Park, Suite 300 Tampa, FL 33637 USA
              </p>
            </section>
            <section class="md-layout-item md-size-100 mb-6">
              <h3 class="text-2xl font-bold text-center mb-3 text-[#2d82b5]">
                Dashboard
              </h3>

              <p class="font-medium mb-2">
                1. General information
              </p>
              <md-table class="table-dashboard-pdf">
                <md-table-row>
                  <md-table-cell class="font-medium bg-[#ABE0FF] text-center">
                    Title
                  </md-table-cell>
                  <md-table-cell class="font-medium bg-[#ABE0FF] text-center">
                    Quantity
                  </md-table-cell>
                  <md-table-cell class="font-medium bg-[#ABE0FF] text-center">
                    Status
                  </md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell>Total teachers</md-table-cell>
                  <md-table-cell>
                    {{ dataSynthetic.total_teacher }}
                  </md-table-cell>
                  <md-table-cell>Active</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell>Total students</md-table-cell>
                  <md-table-cell>
                    {{ dataSynthetic.total_student }}
                  </md-table-cell>
                  <md-table-cell>Active</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell>Total counselors</md-table-cell>
                  <md-table-cell>
                    {{ dataSynthetic.total_counselor }}
                  </md-table-cell>
                  <md-table-cell>Active</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell>Total classes</md-table-cell>
                  <md-table-cell>
                    {{ dataSynthetic.total_class }}
                  </md-table-cell>
                  <md-table-cell>On-going</md-table-cell>
                </md-table-row>
              </md-table>
            </section>
            <section class="md-layout-item md-size-100 mb-6">
              <p class="font-medium mb-2">
                2. Studying student by gender
              </p>
              <card-dashboard>
                <div class="md-layout mt-8">
                  <div class="md-layout-item md-size-100 mb-3">
                    <gender-chart-admin
                      :gender="dataGender"
                      :height="250"
                    ></gender-chart-admin>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-table class="table-dashboard-pdf">
                      <md-table-row>
                        <md-table-cell
                          class="font-medium bg-[#ABE0FF] text-center"
                        >
                          Sex
                        </md-table-cell>
                        <md-table-cell
                          v-for="(gender, index) in dataGender.label"
                          :key="'gender' + index"
                          class="font-medium bg-[#ABE0FF] text-center"
                        >
                          {{ gender }}
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell class="font-medium">
                          Quantity
                        </md-table-cell>
                        <md-table-cell
                          v-for="(data, index) in dataGender.data"
                          :key="'data' + index"
                        >
                          {{ data }}
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell class="font-medium">
                          Percentage
                        </md-table-cell>
                        <md-table-cell
                          v-for="(percentage, index) in dataGender.percentage"
                          :key="'percentage' + index"
                        >
                          {{ percentage }} %
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </card-dashboard>
            </section>
            <section class="md-layout-item md-size-100">
              <p class="font-medium mb-2">
                3. Studying student by grade
              </p>
              <card-dashboard>
                <div class="md-layout mt-8">
                  <div class="md-layout-item md-size-100 mb-3">
                    <grade-chart-admin
                      :grade="dataGrade"
                      :height="250"
                    ></grade-chart-admin>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-table class="table-dashboard-pdf">
                      <md-table-row>
                        <md-table-cell
                          class="font-medium bg-[#ABE0FF] text-center"
                        >
                          Grade
                        </md-table-cell>
                        <md-table-cell
                          class="font-medium bg-[#ABE0FF] text-center"
                        >
                          Quantity
                        </md-table-cell>
                        <md-table-cell
                          class="font-medium bg-[#ABE0FF] text-center"
                        >
                          Percentage
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row
                        v-for="(grade, key, index) in tableGrade"
                        :key="'tableGrade' + index"
                      >
                        <md-table-cell>{{ key }}</md-table-cell>
                        <md-table-cell>{{ grade.data }}</md-table-cell>
                        <md-table-cell>{{ grade.percent }} %</md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </card-dashboard>
            </section>
          </section>
        </template>
      </pdf-default>
    </div>
    <!-- DOWNLOAD PDF -->

    <div class="md-layout-item md-size-70 md-medium-size-100 px-0">
      <!-- GREETING -->
      <div class="md-layout-item">
        <greeting :info="info"></greeting>
      </div>
      <!-- GREETING -->

      <!-- DATA SYNTHETIC -->
      <synthetic :data="dataSynthetic"></synthetic>
      <!-- DATA SYNTHETIC -->

      <!-- CHART GRADE & GENDER -->
      <div class="md-layout">
        <div class="md-layout-item md-size-50">
          <div ref="chartGrade">
            <card-dashboard :title="$t('dashboard.chart_grade')">
              <div class="md-layout mt-8">
                <div class="md-layout-item md-size-100">
                  <grade-chart-admin
                    :grade="dataGrade"
                    :height="300"
                  ></grade-chart-admin>
                </div>
              </div>
            </card-dashboard>
          </div>
        </div>

        <div class="md-layout-item md-size-50">
          <card-dashboard
            :title="$t('dashboard.chart_gender')"
            :style="{ height: heightChart }"
          >
            <div class="md-layout mt-8">
              <div class="md-layout-item md-size-100">
                <gender-chart-admin
                  :gender="dataGender"
                  :height="300"
                ></gender-chart-admin>
              </div>
            </div>
          </card-dashboard>
        </div>
      </div>
      <!-- CHART GRADE & GENDER -->
    </div>

    <div class="md-layout-item md-size-30 md-medium-size-100">
      <external-link></external-link>
      <!-- UPCOMING EVENTS -->
      <upcoming-events
        :showTakeAttendance="false"
        :path="path.upcomingEvents"
      ></upcoming-events>
      <!-- UPCOMING EVENTS -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UpcomingEvents from "../../Components/UpcomingEvents";
import CardDashboard from "../../Components/CardDashboard";
import { service_paths } from "@/constants/Services";
import GenderChartAdmin from "./GenderChart";
import GradeChartAdmin from "./GradeChart";
import Synthetic from "./Synthetic";
import { initLoader, percentDataChart } from "@/helpers/utils";
import Greeting from "../../Components/Gretting";
import ExternalLink from "../../Components/ExternalLink";
import PdfDefault from "../../../../components/PdfDefault";

export default {
  name: "dashboard-admin",
  components: {
    PdfDefault,
    ExternalLink,
    Greeting,
    Synthetic,
    GradeChartAdmin,
    GenderChartAdmin,
    CardDashboard,
    UpcomingEvents
  },
  data() {
    return {
      path: {
        upcomingEvents: `${service_paths.calendars}/dashboard?type=event`,
        synthetic: `${service_paths.dashboard}/synthetic`,
        gradeChart: `${service_paths.dashboard}/percentage-grade`,
        genderChart: `${service_paths.dashboard}/percentage-gender`
      },
      dataSynthetic: {},
      dataGender: null,
      dataGrade: null,
      upcomingEvents: [],
      heightChart: "",
      tableGrade: {},
      renderPdf: false
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  created() {
    const loader = initLoader();

    Promise.all([
      this.fetchDataSynthetic(),
      this.fetchDataGradeChart(),
      this.fetchDataGenderChart()
    ]).finally(() => {
      loader.hide();
      this.renderPdf = true;
    });
  },
  methods: {
    downloadPdf() {
      this.$refs.pdfContent.generatePdf();
    },

    fetchDataSynthetic() {
      return this.$axios
        .get(
          `${this.path.synthetic}`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          if (data) {
            this.dataSynthetic = data;
          }
        });
    },

    fetchDataGradeChart() {
      return this.$axios
        .get(
          `${this.path.gradeChart}`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          if (data) {
            this.dataGrade = data;
            this.dataGrade["percentage"] = percentDataChart(
              this.dataGrade.data
            );
            this.dataGrade.label.map((label, index) => {
              this.tableGrade[label] = {
                data: this.dataGrade.data[index],
                percent: this.dataGrade.percentage[index]
              };
            });
          }
        });
    },

    fetchDataGenderChart() {
      return this.$axios
        .get(
          `${this.path.genderChart}`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          if (data) {
            this.dataGender = data;
            this.dataGender["percentage"] = percentDataChart(
              this.dataGender.data
            );
          }
        });
    },

    getHeight() {
      this.$nextTick(() => {
        this.heightChart = this.$refs.chartGrade.clientHeight + "px";
      });
    }
  },
  watch: {
    dataGrade() {
      this.getHeight();
    }
  }
};
</script>
<style lang="scss">
.dashboard .btn-download-pdf {
  position: absolute;
  top: 70px;
  left: 160px;
}
</style>
